__turbopack_context__.v({
  "ProductRowSlider": "ProductRowSlider-module__IT_6wW__ProductRowSlider",
  "animated": "ProductRowSlider-module__IT_6wW__animated",
  "button": "ProductRowSlider-module__IT_6wW__button",
  "cardWrapper": "ProductRowSlider-module__IT_6wW__cardWrapper",
  "changer": "ProductRowSlider-module__IT_6wW__changer",
  "left": "ProductRowSlider-module__IT_6wW__left",
  "popIn": "ProductRowSlider-module__IT_6wW__popIn",
  "right": "ProductRowSlider-module__IT_6wW__right",
  "slide": "ProductRowSlider-module__IT_6wW__slide",
  "swiper": "ProductRowSlider-module__IT_6wW__swiper",
});
